import { useState } from 'react';
import {
  ExDropdown,
  ExMenu,
  ExMenuItem,
  ButtonFlavor,
  ButtonType,
  MenuItemVariant,
} from '@boomi/exosphere';
import { ModelRowActionsProps } from '../types/models.types';
import dropdownRefHandler from '@components/ToolManagement/helpers/dropdownRefHandler';
import './ModelRowActions.scss';

function ModelRowActions({
  model,
  onView,
  onEdit,
  onDelete,
  t,
  showEdit = true,
  openDropdownRef,
}: Readonly<ModelRowActionsProps & {
  openDropdownRef?: any;
}>) {
  const [dropdownRef, setDropdownRef] = useState<any>(null);

  const handleMenuItemClick = (action: string) => {
    const refToUse = openDropdownRef?.current || dropdownRef;
    switch (action) {
      case 'view':
        onView?.(model);
        break;
      case 'edit':
        onEdit?.(model);
        break;
      case 'delete':
        onDelete?.(model.id || '');
        break;
      default:
        break;
    }
    refToUse?.closeDropdown();
  };

  const handleDropdownRef = (ref: any) => {
    setDropdownRef(ref);
    if (openDropdownRef) {
      openDropdownRef.current = ref;
    }
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <ExDropdown
        ref={openDropdownRef ? dropdownRefHandler(openDropdownRef) : handleDropdownRef}
        icon="More options"
        text=""
        flavor={ButtonFlavor.BRANDED}
        type={ButtonType.TERTIARY}
        data-testid={`model-actions-${model.id}`}
        className="model-row-actions__dropdown"
      >
        <ExMenu className="model-row-actions__menu">
          <ExMenuItem
            value="view"
            onClick={() => handleMenuItemClick('view')}
            data-testid={`model-action-view-${model.id}`}
          >
            {t('view_details')}
          </ExMenuItem>

          {model.provider !== 'Boomi' && (
            <>
              {showEdit && (
                <ExMenuItem
                  value="edit"
                  onClick={() => handleMenuItemClick('edit')}
                  data-testid={`model-action-edit-${model.id}`}
                >
                  {t('edit')}
                </ExMenuItem>
              )}
              <ExMenuItem
                value="delete"
                variant={MenuItemVariant.RISKY}
                onClick={() => handleMenuItemClick('delete')}
                data-testid={`model-action-delete-${model.id}`}
              >
                {t('favorites_delete')}
              </ExMenuItem>
            </>
          )}
        </ExMenu>
      </ExDropdown>
    </div>
  );
}

export default ModelRowActions;
